// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#flavor-slider .slider-slide");
//   var currentSlide = 0;
//   var prevBtn = document.getElementById("prevBtn");
//   var nextBtn = document.getElementById("nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     var offset = -index * 100 + "%";
//     for (var i = 0; i < slides.length; i++) {
//       slides[i].style.transform = "translateX(" + offset + ")";
//       // slides[i].style.transform = "translate3d(" + offset + ", 0, 0, 0)";

//       slides[i].classList.remove("c-active"); // Remove active class from all slides
//     }
//     slides[index].classList.add("c-active"); // Add active class to the current slide
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     currentSlide++;
//     if (currentSlide >= slides.length) {
//       currentSlide = 0;
//     }
//     showSlide(currentSlide);
//   }

//   function prevSlide() {
//     currentSlide--;
//     if (currentSlide < 0) {
//       currentSlide = slides.length - 1;
//     }
//     showSlide(currentSlide);
//   }

//   function updatePagination() {
//     var dots = "";
//     for (var i = 0; i < slides.length; i++) {
//       var activeClass = i === currentSlide ? "active" : "";
//       dots += `<span class="pagination-dot ${activeClass}" data-slide="${i}"></span>`;
//     }
//     pagination.innerHTML = dots;
//     addPaginationListeners();
//   }

//   function addPaginationListeners() {
//     var paginationDots = pagination.querySelectorAll(".pagination-dot");
//     paginationDots.forEach(function (dot) {
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//     });
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#flavor-slider .slider-slide");
//   var sliderContainer = document.getElementById("flavor-slider");
//   var currentSlide = 0;
//   var prevBtn = document.getElementById("prevBtn");
//   var nextBtn = document.getElementById("nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     if (index < 0) {
//       index = slides.length - 1;
//     } else if (index >= slides.length) {
//       index = 0;
//     }

//     var offset = -index * 100 + "%";
//     sliderContainer.style.transform = "translateX(" + offset + ")";
//     for (var i = 0; i < slides.length; i++) {
//       slides[i].classList.remove("c-active");
//     }

//     slides[index].classList.add("c-active");
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     showSlide(currentSlide + 1);
//   }

//   function prevSlide() {
//     showSlide(currentSlide - 1);
//   }

//   function updatePagination() {
//     pagination.innerHTML = "";
//     for (var i = 0; i < slides.length; i++) {
//       var dot = document.createElement("span");
//       dot.classList.add("pagination-dot");
//       if (i === currentSlide) {
//         dot.classList.add("active");
//       }
//       dot.setAttribute("data-slide", i);
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//       pagination.appendChild(dot);
//     }
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);

//   const variantSelect = document.getElementById('variant-select');
// if (variantSelect) {
//   variantSelect.addEventListener('change', (event) => {
//     const selectedOption = event.target.selectedOptions[0];
//     if (selectedOption) {
//       const textContent = selectedOption.textContent;
//       console.log(textContent);
//     } else {
//       console.error('No option selected');
//     }
//   });
// } else {
//   console.error('Variant select element not found');
// }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#second-slider .slider-slide");
//   var currentSlide = 0;
//   var slidesToShow = 3; // Number of slides to show at once
//   var prevBtn = document.getElementById("sec-prevBtn");
//   var nextBtn = document.getElementById("sec-nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     // Calculate the starting index of the current set of slides to show
//     var startIndex = index * slidesToShow;
//     // Calculate the ending index of the current set of slides to show
//     var endIndex = startIndex + slidesToShow;

//     // Loop through all slides and show/hide based on the calculated indices
//     for (var i = 0; i < slides.length; i++) {
//       if (i >= startIndex && i < endIndex) {
//         slides[i].style.display = "block";
//       } else {
//         slides[i].style.display = "none";
//       }
//       slides[i].classList.remove("active"); // Remove active class from all slides
//     }

//     // Add active class to the current slide
//     slides[index * slidesToShow].classList.add("active");
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     currentSlide++;
//     if (currentSlide >= Math.ceil(slides.length / slidesToShow)) {
//       currentSlide = 0;
//     }
//     showSlide(currentSlide);
//   }

//   function prevSlide() {
//     currentSlide--;
//     if (currentSlide < 0) {
//       currentSlide = Math.ceil(slides.length / slidesToShow) - 1;
//     }
//     showSlide(currentSlide);
//   }

//   function updatePagination() {
//     var dots = "";
//     for (var i = 0; i < Math.ceil(slides.length / slidesToShow); i++) {
//       var activeClass = i === currentSlide ? "active" : "";
//       dots += `<span class="pagination-dot ${activeClass}" data-slide="${i}"></span>`;
//     }
//     pagination.innerHTML = dots;
//     addPaginationListeners();
//   }

//   function addPaginationListeners() {
//     var paginationDots = pagination.querySelectorAll(".pagination-dot");
//     paginationDots.forEach(function (dot) {
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//     });
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);
// });
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelector(".header h2").innerHTML = "abcd";
// });
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        const slideCartElement = document.querySelector(".slidecarthq");

        if (slideCartElement) {
          // Now your code will run when #slidecarthq is detected in the DOM
          observer.disconnect(); // Stop observing once the element is found

          // Accessibility fix: give the cart overlay an accessible name
          const cartOverlayElement = document.querySelector(".slidecarthq-overlay");
          if (cartOverlayElement && !cartOverlayElement.getAttribute("aria-label")) {
            cartOverlayElement.setAttribute("aria-label", "Close cart");
          }

          // Accessibility fix: mark empty cart message as a status region
          const emptyCartContainer = document.querySelector(".empty-cart-text-container");
          if (emptyCartContainer && !emptyCartContainer.getAttribute("role")) {
            emptyCartContainer.setAttribute("role", "status");
          }

          // Your code to update .slidecarthq .header
          const headerElement = document.querySelector(
            ".slidecarthq .header h2"
          );
          if (headerElement) {
            headerElement.innerHTML = `<div class="shoping-cart"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/Vector_Smart_Object.png?v=1722713507" /><h2>Shopping Cart<span class="cart-count">Good Choice Partner. Let's Ride!</span></h2></div>`;
          }

          // Your code to update #slidecart-checkout-form button
          const checkoutButton = document.querySelector(
            "#slidecart-checkout-form button"
          );
          if (checkoutButton) {
            checkoutButton.innerHTML = `<span class="left-vehicle-image"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/stagecoach.png?v=1722756879" /><span class="checkout-class">Secure Checkout</span></span><span class="right-arrow-image"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/Group_25.png?v=1722756880" /></span>`;
          }

          // Your code to update the footer
          const footerRows = document.querySelectorAll(
            "#slidecarthq .footer .footer-row"
          );

          if (footerRows.length >= 2) {
            const secondFooterRow = footerRows[1];
            const subImageElement = secondFooterRow.querySelector(".flex");
            const fireImage = document.createElement("strong");
            fireImage.classList.add("fire-image");
            fireImage.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/bold-flavor-icon.png?v=1719247734"/>`;

            if (secondFooterRow) {
              secondFooterRow.prepend(fireImage);
            }
            const flexElement = secondFooterRow.querySelector(".flex");
            if (flexElement) {
              flexElement.innerHTML = "Subtotal";
            }
          }
        }
      }
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, { childList: true, subtree: true });
});

// Product detail scroll issue work
const variantClickCustomHandler = () => {
  const previousScrollHeight = window.scrollY;
  window.scrollTo(0, previousScrollHeight);

  for (let i = 0; i < 500; i++) {
    setTimeout(() => {
      window.scrollTo(0, previousScrollHeight);
    }, i);
  }
};

const selectVariantBtns = document.querySelectorAll(
  ".template-product .product-variant__item--radio"
);

selectVariantBtns.forEach((singleSelector) => {
  singleSelector.addEventListener("click", variantClickCustomHandler);
});
const selectPlusBtn = document.querySelector(".template-product .qty-plus");
const selectMinusBtn = document.querySelector(".template-product .qty-minus");
const selectPlusMinusInput = document.querySelector(
  ".template-product .product__quantity"
);
// function QuantityPlusMinus() {
//   const originalPricePerItem = document.querySelector(
//     "#originalProductPrice"
//   ).value;
//   const updateQuantity = (increment) => {
//     let currentQuantity = parseInt(selectPlusMinusInput.value);

//     currentQuantity += increment;

//     console.log({ currentQuantity }, "currentQuantitycurrentQuantity");

//     if (currentQuantity < 1) {
//       currentQuantity = 1;
//     }

//     console.log({ increment, currentQuantity }, "currentQuantity");

//     selectPlusMinusInput.value = currentQuantity;

//     const updatedPrice = originalPricePerItem * currentQuantity;
//     document.querySelector(
//       ".product-price--original"
//     ).innerText = `$${updatedPrice.toFixed(2)}`;
//   };

//   selectPlusBtn.addEventListener("click", () => {
//     updateQuantity(1);
//   });

//   selectMinusBtn.addEventListener("click", () => {
//     updateQuantity(-1);
//   });
// }
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const getOriginalPrice = document.querySelector(".product-price--original");

    const originalProductPriceValue = getOriginalPrice?.innerText?.replace(
      "$",
      ""
    );

    let hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "originalProductPrice";
    hiddenInput.id = "originalProductPrice";

    hiddenInput.value = originalProductPriceValue;

    document.body.append(hiddenInput);
  }, 1000);

  // QuantityPlusMinus();

  // const extraBtn = document.querySelectorAll(".pagination .lap-hide");
  // const prevElement = document.querySelector(".pagination .prev a");
  // const nextElement = document.querySelector(".pagination .next a");

  // extraBtn.forEach((single) => {
  //   single.style.display = "none";
  // });
  // prevElement.innerHTML = `<button class="pagination-back-btn">
  //   <img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/vector-left-arrow.png?v=1722935524" width="13px" height="13px">
  //   Back
  // </button>`
  // nextElement.innerHTML = `<button class="pagination-next-btn">
  //   Next
  //   <img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/vector-right-arrow.png?v=1722935525" width="13px" height="13px">
  // </button>`
});

document.addEventListener("DOMContentLoaded", () => {
  const qtyDropdownObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const qtyDropdown = entry.target;

        qtyDropdown.addEventListener("change", function (event) {
          const getOriginalPrice = document.querySelector(
            ".product-price--original"
          );
          const getHiddenOriginalPriceValue = document.querySelector(
            "#originalProductPrice"
          )?.value;

          if (getOriginalPrice && getHiddenOriginalPriceValue) {
            const multipliedValue =
              getHiddenOriginalPriceValue * event.target.value;
            getOriginalPrice.innerText = `$ ${multipliedValue.toFixed(2)}`;
          }
        });

        // Disconnect the observer after the event listener is added
        qtyDropdownObserver.disconnect();
      }
    });
  });

  // Start observing the qty dropdown element
  const qtyDropdownElement = document.querySelector(
    ".template-product #custom-qty-dropdown-detail-p"
  );
  if (qtyDropdownElement) {
    qtyDropdownObserver.observe(qtyDropdownElement);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const paginationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Your JavaScript to run when pagination is loaded
        document.querySelector(
          `.pagination .prev span[aria-hidden="true"]`
        ).innerHTML = `  <div class="next-page-custom-styling back-page-custom-styling">
          <div><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/black-arrow-icon.png?v=1719511448" width="50" height="50"></div>
          <div>Back</div> 
        </div>`;

        document.querySelector(
          `.pagination .next span[aria-hidden="true"]`
        ).innerHTML = `<div class="next-page-custom-styling">
                        <div> Next
                        </div> 
                        <div><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/black-arrow-icon.png?v=1719511448" width="50" height="50"></div>
                      </div>`;

        // Disconnect the observer after it has run once
        paginationObserver.disconnect();
      }
    });
  });

  // Start observing the pagination element
  const paginationElement = document.querySelector(
    "#main-collection-product-grid .pagination"
  );
  if (paginationElement) {
    paginationObserver.observe(paginationElement);
  }
}); 
document.addEventListener("DOMContentLoaded", function () { 
  const sidebar = document.getElementById("site-filters-sidebar");
  const closeSidebar = () => {
    sidebar.style.cssText =
      "transform: translate(100%);";
  };
  const openSidebar = () => {
    sidebar.style.cssText =
      "transform: translate(0%);";
  };
  Array.from(document.getElementsByClassName("sidebar__close")).forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      closeSidebar();
    });
  });
  const observer = new MutationObserver(function (mutationsList, observer) {
    document
    .getElementById("collection-filters-handle")
    .addEventListener("click", function (event) {
      event.preventDefault();
      console.log("Clicked open!");
      openSidebar();
    });

  });

  const observerConfig = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };
  if (sidebar) {
    observer.observe(sidebar, observerConfig);
  }
});




















// Accessibility fix: remove duplicate banner landmark from unused legacy header markup
document.addEventListener('DOMContentLoaded', function () {
  const legacyHeader = document.querySelector('header.c-custom-header');
  if (legacyHeader) {
    const replacement = document.createElement('div');
    replacement.className = legacyHeader.className;
    replacement.innerHTML = legacyHeader.innerHTML;
    legacyHeader.replaceWith(replacement);
  }
});

// Accessibility fix: give any image missing alt text a safe default
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('img:not([alt])').forEach(function (img) {
    img.setAttribute('alt', '');
  });
});

// Accessibility fix: safety-net alt text for footer/social/cart icons
document.addEventListener('DOMContentLoaded', function () {
  const altMap = [
    { selector: '.footer-head > img', alt: 'Outlaw Dip Company' },
    { selector: 'a[href*="facebook.com"] > img', alt: 'Facebook (opens in new window)' },
    { selector: 'a[href*="instagram.com"] > img', alt: 'Instagram (opens in new window)' },
    { selector: 'a[href*="youtube.com"] > img', alt: 'YouTube (opens in new window)' },
    { selector: 'a[href*="tiktok.com"] > img', alt: 'TikTok (opens in new window)' },
    { selector: 'a[href*="x.com"] > img', alt: 'X (opens in new window)' },
    { selector: '.cart-icon-p', alt: '' },
    { selector: '.left-img', alt: '' }
  ];

  altMap.forEach(function (item) {
    document.querySelectorAll(item.selector).forEach(function (img) {
      if (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '') {
        img.setAttribute('alt', item.alt);
      }
    });
  });
});

// Accessibility fix: de-duplicate custom-variant-Size/Strength IDs
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="custom-variant-"]').forEach(function (elm, index) {
    elm.id = elm.id + '-' + index;
  });
});

// Accessibility fix: remove duplicate blog-page-end-dashed-hr IDs
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('#blog-page-end-dashed-hr').forEach(function (elm, index) {
    if (index > 0) {
      elm.removeAttribute('id');
    }
  });
});
// ACCESSIBILITY FIXES - Missing alt text remediation
(function () {
  var decorativeSelectors = [
    '.footer-head img',
    '.left-img',
    '.white-btn img',
    '.c-horse',
    'a[href$="custom-outlaw-story"] .c-common-button img',
    '.cart-icon-p',
    '.faceBookShare img',
    '.xShare img',
    '.see-more-btn img'
  ];
  var contentImageFixes = [
    { selector: '.right-into img, .right-info img', alt: 'Fairground Freeze limited edition flavor announcement' },
    { selector: 'div:nth-child(1) > .experience-image', alt: 'Outlaw Straight Gold pouches' },
    { selector: 'div:nth-child(3) > .experience-image', alt: 'Outlaw Dip product lineup cans' }
  ];
  function applyFixes() {
    decorativeSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (img) {
        if (!img.hasAttribute('alt')) {
          img.setAttribute('alt', '');
        }
      });
    });
    contentImageFixes.forEach(function (fix) {
      document.querySelectorAll(fix.selector).forEach(function (img) {
        if (!img.hasAttribute('alt')) {
          img.setAttribute('alt', fix.alt);
        }
      });
    });
    document.querySelectorAll('.faceBookShare, .xShare').forEach(function (link) {
      if (!link.hasAttribute('aria-label') && !link.textContent.trim()) {
        link.setAttribute('aria-label', link.classList.contains('faceBookShare') ? 'Share on Facebook' : 'Share on X');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }
  var observer = new MutationObserver(function () {
    applyFixes();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Owl Carousel prev/next buttons missing accessible names
(function () {
  function fixCarouselNavButtons() {
    document.querySelectorAll('.owl-prev').forEach(function (btn) {
      if (btn.getAttribute('role') === 'presentation') {
        btn.removeAttribute('role');
      }
      if (!btn.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Previous slide');
      }
    });
    document.querySelectorAll('.owl-next').forEach(function (btn) {
      if (btn.getAttribute('role') === 'presentation') {
        btn.removeAttribute('role');
      }
      if (!btn.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Next slide');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCarouselNavButtons);
  } else {
    fixCarouselNavButtons();
  }
  var observer = new MutationObserver(function () {
    fixCarouselNavButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Tag low-contrast "Cart" label for CSS override
(function () {
  function tagCartLabel() {
    document.querySelectorAll('header > span').forEach(function (span) {
      if (span.textContent.trim() === 'Cart' && !span.classList.contains('a11y-contrast-fix')) {
        span.classList.add('a11y-contrast-fix');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagCartLabel);
  } else {
    tagCartLabel();
  }
  var observer = new MutationObserver(function () {
    tagCartLabel();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Focusable divs without interactive roles/behavior
(function () {

  function fixGalleryItems() {
    document.querySelectorAll('.product-gallery-item').forEach(function (item) {
      if (item.id && item.id.indexOf('FeaturedMedia-') === 0) return;
      if (item.closest('.owl-carousel')) {
        if (item.getAttribute('role') === 'button') {
          item.removeAttribute('role');
        }
        return;
      }
      if (!item.hasAttribute('role')) {
        item.setAttribute('role', 'button');
      }
      if (!item.hasAttribute('aria-label')) {
        var index = item.getAttribute('data-index');
        item.setAttribute('aria-label', 'View product image ' + (index !== null ? (parseInt(index, 10) + 1) : ''));
      }
      if (!item.dataset.a11yKeyBound) {
        item.dataset.a11yKeyBound = 'true';
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.click();
          }
        });
      }
    });
  }

  function fixCarouselSlides() {
    document.querySelectorAll('.blog-item[tabindex="0"]').forEach(function (slide) {
      if (!slide.classList.contains('slick-current') && !slide.classList.contains('slick-active')) {
        slide.setAttribute('tabindex', '-1');
      }
    });
  }

  function applyFixes() {
    fixGalleryItems();
    fixCarouselSlides();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }

  var observer = new MutationObserver(function () {
    applyFixes();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex']
  });

})();

// ACCESSIBILITY FIXES - Heading hierarchy correction (non-destructive)
// Uses role="presentation" / role="heading"+aria-level instead of physically
// replacing tags, so no existing CSS (tag selectors, :hover rules) or JS
// event bindings tied to the original tag name are ever broken.
(function () {
  function stripHeadingRole(el) {
    if (!el || el.dataset.a11yFixed) return;
    el.setAttribute('role', 'presentation');
    el.dataset.a11yFixed = 'true';
  }
  function reassignHeadingLevel(el, level) {
    if (!el || el.dataset.a11yFixed) return;
    el.setAttribute('role', 'heading');
    el.setAttribute('aria-level', level);
    el.dataset.a11yFixed = 'true';
  }
  function fixHeadingHierarchy() {
    // "START YOUR JOURNEY..." - promote to level 2 semantically, keep <h3> tag
    document.querySelectorAll('.text-styling > h3').forEach(function (h3) {
      reassignHeadingLevel(h3, 2);
    });
    // "PRICE" label - not a real heading
    document.querySelectorAll('h6').forEach(function (h6) {
      if (h6.textContent.trim() !== 'PRICE') return;
      stripHeadingRole(h6);
    });
    // Privacy policy title - promote to level 2
    document.querySelectorAll('#privacy-policy-main > h3').forEach(function (h3) {
      if (h3.textContent.indexOf('PRIVACY STATEMENT') === -1) return;
      reassignHeadingLevel(h3, 2);
    });
    // Remaining privacy-policy h5's - not real subheadings
    document.querySelectorAll('#privacy-policy-main h5').forEach(function (h5) {
      stripHeadingRole(h5);
    });
    // Nav "Home", "Moist Snuff" etc links wrapped in <h3> for styling only
    document.querySelectorAll('#c-nav-1 > h3, #c-nav-2 > h3').forEach(function (h3) {
      stripHeadingRole(h3);
    });
    // Mobile search icon wrapped in <h3>
    document.querySelectorAll('.c-mubile--top .c-icon-nav').forEach(function (el) {
      if (el.tagName.toLowerCase() !== 'h3') return;
      stripHeadingRole(el);
    });
    // Blog page detail heading - promote to level 2
    document.querySelectorAll('.detail-sec-body > h3.blog-page-texts').forEach(function (h3) {
      reassignHeadingLevel(h3, 2);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeadingHierarchy);
  } else {
    fixHeadingHierarchy();
  }
})();

// ACCESSIBILITY FIXES - Remove duplicate banner landmark from main-header element
// main-header#site-header explicitly declares role="banner", but a separate,
// unrelated <header> tag on the same page already carries an implicit role="banner"
// automatically. Having both creates two banner landmarks on one page.
// Removing the explicit role from main-header leaves exactly one correct banner.
(function () {

  function fixMainHeaderBanner() {
    var mainHeader = document.getElementById('site-header');
    if (mainHeader && mainHeader.getAttribute('role') === 'banner') {
      mainHeader.removeAttribute('role');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMainHeaderBanner);
  } else {
    fixMainHeaderBanner();
  }

})();

// ACCESSIBILITY FIXES - Wrap navigation content in landmark regions
// #c-nav-1, #c-nav-2, and #flying-logo currently sit outside any landmark
// region (nav, banner, main, etc.), so every link/icon inside them gets
// flagged individually. Giving each container a proper landmark role
// resolves all nested items in one fix.
(function () {
  function fixNavLandmarks() {
    var nav1 = document.getElementById('c-nav-1');
    if (nav1 && !nav1.getAttribute('role') && nav1.tagName !== 'NAV') {
      nav1.setAttribute('role', 'navigation');
      nav1.setAttribute('aria-label', 'Main navigation');
    }
    var nav2 = document.getElementById('c-nav-2');
    if (nav2 && !nav2.getAttribute('role') && nav2.tagName !== 'NAV') {
      nav2.setAttribute('role', 'navigation');
      nav2.setAttribute('aria-label', 'Account and cart navigation');
    }
    var logo = document.getElementById('flying-logo');
    if (logo && !logo.closest('[role="banner"], header, nav, [role="navigation"]')) {
      logo.setAttribute('role', 'navigation');
      logo.setAttribute('aria-label', 'Site logo');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixNavLandmarks);
  } else {
    fixNavLandmarks();
  }
})();

// ACCESSIBILITY FIXES - Wrap mobile navigation content in landmark regions
// Mobile-specific nav elements (.c-mubile--top, .cart--burger, .c-mubile--menu)
// are separate from the desktop #c-nav-1/#c-nav-2 containers already fixed,
// and sit outside any landmark region on smaller viewports.
(function () {
  function fixMobileNavLandmarks() {
    var mobileTop = document.querySelector('.c-mubile--top');
    if (mobileTop && !mobileTop.getAttribute('role') && mobileTop.tagName !== 'NAV') {
      mobileTop.setAttribute('role', 'navigation');
      mobileTop.setAttribute('aria-label', 'Mobile search and logo');
    }
    var cartBurger = document.querySelector('.cart--burger');
    if (cartBurger && !cartBurger.getAttribute('role') && cartBurger.tagName !== 'NAV') {
      cartBurger.setAttribute('role', 'navigation');
      cartBurger.setAttribute('aria-label', 'Cart');
    }
    var mobileMenu = document.querySelector('.c-mubile--menu');
    if (mobileMenu && !mobileMenu.getAttribute('role') && mobileMenu.tagName !== 'NAV') {
      mobileMenu.setAttribute('role', 'navigation');
      mobileMenu.setAttribute('aria-label', 'Mobile menu');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileNavLandmarks);
  } else {
    fixMobileNavLandmarks();
  }
  var observer = new MutationObserver(function () {
    fixMobileNavLandmarks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Establish proper carousel slide semantics
// Owl Carousel slides are draggable/swipeable via JS (not visible as role/tabindex),
// while .product-gallery-item inside each slide is a real button (View image).
// Marking .owl-item as a "slide" container clarifies for assistive tech that
// it's a carousel slide wrapper, not a competing interactive control.
(function () {
  function fixCarouselSlideSemantics() {
    document.querySelectorAll('.owl-item').forEach(function (item) {
      if (!item.hasAttribute('role')) {
        item.setAttribute('role', 'group');
      }
      if (!item.hasAttribute('aria-roledescription')) {
        item.setAttribute('aria-roledescription', 'slide');
      }
    });
    var carousel = document.querySelector('.owl-carousel');
    if (carousel && !carousel.hasAttribute('role')) {
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-label', 'Product image gallery');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCarouselSlideSemantics);
  } else {
    fixCarouselSlideSemantics();
  }
  var observer = new MutationObserver(function () {
    fixCarouselSlideSemantics();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Prevent focusable duplicate gallery items (nested interactive controls)
// The theme renders both a desktop and mobile version of each product gallery
// image, with one nested inside the other in the DOM. Our earlier fix made
// every .product-gallery-item focusable/interactive, which created a button
// nested inside a button. Only the visible-per-viewport version should be
// interactive; the hidden duplicate should be excluded from the tab order.
(function () {
  function isVisible(el) {
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }
  function fixNestedGalleryItems() {
    document.querySelectorAll('.product-gallery-item').forEach(function (item) {
      var nestedDuplicate = item.querySelector('.product-gallery-item');
      if (nestedDuplicate) {
        if (!isVisible(item) && isVisible(nestedDuplicate)) {
          item.setAttribute('tabindex', '-1');
          item.removeAttribute('role');
          item.setAttribute('aria-hidden', 'true');
        } else if (isVisible(item) && !isVisible(nestedDuplicate)) {
          nestedDuplicate.setAttribute('tabindex', '-1');
          nestedDuplicate.removeAttribute('role');
          nestedDuplicate.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixNestedGalleryItems);
  } else {
    fixNestedGalleryItems();
  }
  var observer = new MutationObserver(function () {
    fixNestedGalleryItems();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', fixNestedGalleryItems);
})();

// ACCESSIBILITY FIXES - Add missing H1 to pages that have none
// Screen reader users rely on an H1 for page orientation. These 4 pages
// have no H1 at all. Adding a visually-hidden H1 satisfies the requirement
// without any visual change to the page.
(function () {
  var pageTitles = {
    '/': 'Outlaw Dip - Be an Outlaw',
    '/pages/rewards': 'Outlaw Dip Rewards Program',
    '/pages/blog-page': 'Outlaw Dip Blog',
    '/pages/custom-outlaw-story': 'How We Became Outlaws'
  };
  function addMissingH1() {
    var path = window.location.pathname;
    if (document.querySelector('h1')) return;
    if (!pageTitles.hasOwnProperty(path)) return;
    var h1 = document.createElement('h1');
    h1.textContent = pageTitles[path];
    h1.style.position = 'absolute';
    h1.style.width = '1px';
    h1.style.height = '1px';
    h1.style.padding = '0';
    h1.style.margin = '-1px';
    h1.style.overflow = 'hidden';
    h1.style.clip = 'rect(0, 0, 0, 0)';
    h1.style.whiteSpace = 'nowrap';
    h1.style.border = '0';
    var main = document.getElementById('main');
    if (main) {
      main.insertBefore(h1, main.firstChild);
    } else {
      document.body.insertBefore(h1, document.body.firstChild);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addMissingH1);
  } else {
    addMissingH1();
  }
})();

// ACCESSIBILITY FIXES - Duplicate ID remediation (Lootly + Yotpo third-party widgets)
(function () {
  var REF_ATTRS = ['fill', 'clip-path', 'mask', 'filter', 'href', 'xlink:href', 'aria-describedby', 'aria-labelledby', 'aria-controls', 'for'];

  function collectAllIds() {
    var set = new Set();
    document.querySelectorAll('[id]').forEach(function (el) {
      set.add(el.getAttribute('id'));
    });
    return set;
  }

  function makeUniqueId(baseId, usedIds) {
    var counter = 2;
    var candidate = baseId + '-dup-' + counter;
    while (usedIds.has(candidate)) {
      counter++;
      candidate = baseId + '-dup-' + counter;
    }
    return candidate;
  }

  function fixReferencesInScope(scope, oldId, newId) {
    if (!scope) return;
    var urlOld = 'url(#' + oldId + ')';
    var urlNew = 'url(#' + newId + ')';
    var hashOld = '#' + oldId;
    REF_ATTRS.forEach(function (attr) {
      scope.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var val = el.getAttribute(attr);
        if (val === urlOld) {
          el.setAttribute(attr, urlNew);
        } else if (val === hashOld) {
          el.setAttribute(attr, '#' + newId);
        }
      });
    });
  }

  function dedupeIds() {
    var usedIds = collectAllIds();
    var seenOriginal = {};
    document.querySelectorAll('[id]').forEach(function (el) {
      var id = el.getAttribute('id');
      if (!id) return;
      if (!seenOriginal[id]) {
        seenOriginal[id] = true;
        return;
      }
      var newId = makeUniqueId(id, usedIds);
      usedIds.add(newId);
      var scope = el.closest('.yotpo-review-card, .swiper-slide, .swiper-slide-duplicate, svg, .widget-closed, #lootly-widget') || el.parentElement || document;
      el.setAttribute('id', newId);
      fixReferencesInScope(scope, id, newId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedupeIds);
  } else {
    dedupeIds();
  }
  var observer = new MutationObserver(function () {
    dedupeIds();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setInterval(dedupeIds, 150);
})();

// ACCESSIBILITY FIXES - Select dropdowns missing accessible names
(function () {
  function labelSortBySelects() {
    document.querySelectorAll('#desktop-SortBy').forEach(function (select) {
      if (!select.hasAttribute('aria-label') && !select.getAttribute('aria-labelledby')) {
        select.setAttribute('aria-label', 'Sort by');
      }
    });
  }
  function labelByobSelects() {
    document.querySelectorAll('select.byob-gpo-select').forEach(function (select) {
      if (select.hasAttribute('aria-label') || select.getAttribute('aria-labelledby')) return;
      var placeholder = select.querySelector('option[disabled][value=""]');
      var labelText = placeholder ? placeholder.textContent.trim().replace(/:$/, '') : 'Product option';
      select.setAttribute('aria-label', labelText);
    });
  }
  function applyFixes() {
    labelSortBySelects();
    labelByobSelects();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }
  var observer = new MutationObserver(function () {
    applyFixes();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Remove nested interactive control from FeaturedMedia-mobile
// Each .product-gallery-item is our intentional interactive button (role=button,
// aria-label, keydown handler). The theme separately renders a nested
// FeaturedMedia-mobile-* element inside it with its own tabindex="0" role="button",
// creating a button nested inside a button. The inner one is redundant, so we
// strip its interactive semantics and hide it from assistive tech, leaving only
// the outer .product-gallery-item as the single focusable control.
(function () {
  function fixNestedFeaturedMedia() {
    document.querySelectorAll('.product-gallery-item [id^="FeaturedMedia-mobile"]').forEach(function (el) {
      if (el.getAttribute('role') === 'button') {
        el.removeAttribute('role');
      }
      if (el.getAttribute('tabindex') === '0') {
        el.setAttribute('tabindex', '-1');
      }
      if (!el.hasAttribute('aria-hidden')) {
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixNestedFeaturedMedia);
  } else {
    fixNestedFeaturedMedia();
  }
  var observer = new MutationObserver(function () {
    fixNestedFeaturedMedia();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// ACCESSIBILITY FIXES - Remove inappropriate tabindex from carousel slide group
// .blog-item carries role="group" (a non-interactive container role) but also
// tabindex="0", putting it in the keyboard focus order as if it were a control.
// The actual interactive elements (image link, title link, read more link)
// inside it are already independently focusable, so the group wrapper doesn't
// need to be tabbable itself. This also covers Slick's cloned slides, which
// carry the same role/tabindex combination.
(function () {
  function fixBlogItemGroupFocus() {
    document.querySelectorAll('.blog-item[role="group"][tabindex="0"]').forEach(function (item) {
      item.setAttribute('tabindex', '-1');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBlogItemGroupFocus);
  } else {
    fixBlogItemGroupFocus();
  }
  var observer = new MutationObserver(function () {
    fixBlogItemGroupFocus();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
})();